/**
 * Normalização de texto para busca.
 *
 * Precisa produzir exatamente o mesmo resultado que `tools/cataloger/src/lib/text.ts`,
 * porque a busca compara o termo digitado com o `normalizedName` gravado pelo
 * catalogador. Há teste garantindo a equivalência sobre o catálogo real.
 *
 * Propriedade importante: a normalização **preserva o comprimento** do texto (NFD
 * separa o diacrítico e ele é removido, sem alterar a letra base). Isso permite que
 * o índice encontrado no texto normalizado seja usado para destacar o trecho no texto
 * original, com acento e tudo.
 */
export function normalizeText(input: string): string {
  return input
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}
